import React, { useEffect, useState } from 'react'
import api from '../components/api';
import io from 'socket.io-client'
import { dataTableRender, removeDuplicates } from '../components/functions'




const Home = () => {

    var [usuariosOn, setUsuariosOn] = useState()
    var [listaUsuariosOn, setListaUsuariosOn] = useState()


    var [totalAdesoesInstitucionais, setTotalAdesoesInstitucionais] = useState(0)
    var [totalDesafioClima, setTotalDesafioClima] = useState(0)
    var [totalResiduos, setTotalResiduos] = useState(0)
    var [totalEnergia, setTotalEnergia] = useState(0)
    var [totalCompras, setTotalCompras] = useState(0)
    


    async function renderizaUsuarios() {

        if (listaUsuariosOn) {

            //console.log(listaUsuariosOn)

            setUsuariosOn(listaUsuariosOn.map((rs) => 

                <tr>
                    <td>
                        {rs.nome}
                    </td>
                </tr>
                
            ))


            //dataTableRender('tabelaUsuariosOn')
            
        }

    }


            
      



    useEffect(() => {

        renderizaUsuarios()        

    }, [listaUsuariosOn])


    useEffect(() => {

        //var socket = io('http://172.16.1.253:3600');
        var socket = io(process.env.REACT_APP_API);

            

        var nome = sessionStorage.getItem('nome')
        var us_codigo = sessionStorage.getItem('us_codigo')

        
        
        /*
        socket.emit('news', { hello: 'world' });

        socket.on('message', function (message) {
            console.log(message);
        });

        */

        var dataPost = { 
            
            nome: nome, 
            us_codigo: us_codigo,
        
        }

        socket.emit('news', dataPost);

        /*
        socket.on('message', function (message) {
            //console.log(message, '!!');
        });
        */
       


        
          
        socket.on('usuariosOn', function (usuariosOn) {
            
            //console.log(usuariosOn.filter(onlyUnique), '!?')
            setListaUsuariosOn(removeDuplicates(usuariosOn, "nome"))
            
        });

        socket.on('previousMessages', function(message) {
            //console.log(message)
            /*
            var dataPost = {
                us_codigo: sessionStorage.getItem('us_codigo'),
                nome: sessionStorage.getItem('nome'),
            }
            message.push(dataPost)
            */
           //console.log('aqui')
           
            var existe = false

            for (var i = 0; i < message.length; i++) {

                if (message[i].us_codigo == sessionStorage.getItem('us_codigo')) {
                    var existe = true
                    break;
                }

            }
            
            if (!existe) {

                var dataPost = {
                    us_codigo: sessionStorage.getItem('us_codigo'),
                    nome: sessionStorage.getItem('nome'),
                }
                message.push(dataPost)

            }

            setListaUsuariosOn(removeDuplicates(message, "nome"))

        })
          

          
        
    }, [])



    async function adesaoInstitucionalConta() {

        await api.get('adesaoInstitucionalConta').then((result) => {
            //console.log(result.data)
            setTotalAdesoesInstitucionais(result.data[0].total)
        }).catch((err) => {
            console.log(err.response)
        })

    }


    async function desafioClimaConta() {

        await api.get('desafioClimaConta').then((result) => {
            //console.log(result.data)
            setTotalDesafioClima(result.data[0].total)
        }).catch((err) => {
            console.log(err.response)
        })

    }


    async function residuosConta() {

        await api.get('residuosConta').then((result) => {
            //console.log(result.data)
            setTotalResiduos(result.data[0].total)
        }).catch((err) => {
            console.log(err.response)
        })

    }


    async function energiaConta() {

        await api.get('energiaConta').then((result) => {
            //console.log(result.data)
            setTotalEnergia(result.data[0].total)
        }).catch((err) => {
            console.log(err.response)
        })

    }

    async function comprasConta() {

        await api.get('comprasConta').then((result) => {
            //console.log(result.data)
            setTotalCompras(result.data[0].total)
        }).catch((err) => {
            console.log(err.response)
        })

    }


    useEffect(() => {

        adesaoInstitucionalConta()
        desafioClimaConta()
        residuosConta()
        energiaConta()
        comprasConta()

        }, []);


    return (
        <div>

            
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-graph2'></i>
                </div>
                <div class='header-title'>
                    <h1>Dashboard</h1>
                    <small>Site Administrativo</small>
                    
                </div>
            </div>


            <div className='row'>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3" style={{ display: 'none'}}>
                    <div class="statistic-box statistic-filled-3">
                        <h2><span class='count-number'>{totalAdesoesInstitucionais}</span> </h2>
                        <div class='small'>Adesões Institucionais</div>
                        <i class="ti-world statistic_icon"></i>
                        <div class="sparkline3 text-center"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <div class="statistic-box statistic-filled-1">
                        <h2><span class='count-number'>{totalDesafioClima}</span></h2>
                        <div class='small'>Desafio Clima</div>
                        <i class="ti-server statistic_icon"></i>
                        <div class="sparkline1 text-center"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <div class="statistic-box statistic-filled-2">
                        <h2><span class='count-number'>{totalResiduos}</span></h2>
                        <div class='small'>Resíduos SS</div>
                        <i class="ti-user statistic_icon"></i>
                        <div class="sparkline2 text-center"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <div class="statistic-box statistic-filled-4">
                        <h2><span class='count-number'>{totalEnergia}</span></h2>
                        <div class='small'>Desafio Energia</div>
                        <i class="ti-bag statistic_icon"></i>
                        <div class="sparkline4 text-center"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <div class="statistic-box statistic-filled-3">
                        <h2><span class='count-number'>{totalCompras}</span> </h2>
                        <div class='small'>Desafio Compras</div>
                        <i class="ti-world statistic_icon"></i>
                        <div class="sparkline3 text-center"></div>
                    </div>
                </div>
            </div>


            <div className="table-responsive">
                <table id="tabelaUsuariosOn" className="table table-bordered table-striped table-hover">
                    <thead>
                            <tr>
                                
                                <th style={{ backgroundColor: '#FFF'}}>
                                    
                                    Online
                                    

                                </th>
                            </tr>
                            {usuariosOn}
                    </thead>
                </table>
            </div>
        

        <div className='row' style={{ display: 'none'}}>


            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-12">
                <div class="panel panel-bd lobidisable">
                    <div class='panel-heading'>
                        <div class='panel-title'>
                            <i class='ti-stats-up'></i>
                            <h4>Atividades Recentes</h4>
                        </div>
                    </div>
                    <div class='panel-body'>
                        <ul class="activity-list list-unstyled">
                            <li class='activity-purple'>
                                <small class='text-muted'>9 minutos atrás</small>
                                <p>Houve <span class="label label-success label-pill">1</span> adesão institucional</p>
                            </li>
                            <li class='activity-danger'>
                                <small class='text-muted'>15 minutos atrás</small>
                                <p>Notícia postada por <span class="label label-warning label-pill">Fulano da Silva</span></p>
                            </li>
                            <li class='activity-warning'>
                                <small class='text-muted'>22 minutos atrás</small>
                                <p>Houve <span class='text-danger'>1</span> adesão individual</p>
                            </li>
                            <li class='activity-primary' style={{ display: 'none'}}>
                                <small class='text-muted'>30 minutes ago</small>
                                <p>You updated your profile picture</p>
                            </li>
                            <li  style={{ display: 'none'}}>
                                <small class='text-muted' >35 minutes ago</small>
                                <p>You deleted homepage.psd</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>

    </div>
           
    )
}

export default Home